import { FormApplicablePriceDetailsPropsType } from "./type";
import React from "react";
import { getApplicableAmount } from "../util";

export default function useFormApplicablePriceDetailsService(props: FormApplicablePriceDetailsPropsType) {
  const applicableAmount = React.useMemo(() => {
    return getApplicableAmount({
      applicablePrice: props.applicablePrice,
      ticketUpgradeFormDetails: props.ticketUpgradeDetails,
      regParticipantFormDetails: props.regParticipantFormDetails
    });
  }, [props.ticketUpgradeDetails, props.applicablePrice, props.regParticipantFormDetails]);

  const appliedCouponCode = React.useMemo(() => {
    if (props.regParticipantFormDetails.regPurchaseOrder) {
      return props.regParticipantFormDetails.regPurchaseOrder?.lines[0]?.couponCode;
    } else {
      return props.appliedCouponCode;
    }
  }, [props.regParticipantFormDetails.regPurchaseOrder, props.appliedCouponCode]);

  const hasPriceDifference = React.useMemo(() => {
    return props.ticketUpgradeDetails.currentPrice?.value !== applicableAmount?.value;
  }, [props.ticketUpgradeDetails, applicableAmount]);

  return {
    appliedCouponCode,
    hasPriceDifference,
    applicableAmount
  };
}
